/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function UnknownIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "unknown", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 5.5, y: 5.5, width: 14, height: 14, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 16V14.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 13C12.5 11 14 11.5 14 10C14 9.34375 13.5 8.5 12.5 8.5C11.5 8.5 11 9 10.5 9.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(UnknownIcon);
export default ForwardRef;
//# sourceMappingURL=unknownIcon.js.map